export const TIPOS_PLANO = {
    plano_atendimento_especializado: "Plano de Atendimento Especializado",
    estudo_caso_diagnostico: "Estudo de Caso/Diagnóstico",
    plano_atendimento_especializado_pei: "Plano de Atendimento Especializado PEI",
    plano_atendimento_especializado_paee: "Plano de Atendimento Especializado PAEE"
};
